module.exports = __webpack_public_path__ + "img/footer_w.3f4edd33.png";